import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, PhoneCall } from "lucide-react";
import { Reveal } from "@/components/shared/Reveal";
import { useConsultation } from "@/components/forms/ConsultationDialog";
import { COMPANY } from "@/data/content";

export const CTABand = ({
  title = "Stop taking advice from people paid to sell to you.",
  subtitle = "Book a 25-minute honest consultation. No demo, no pitch — just a straight read on where you stand.",
}) => {
  const { open } = useConsultation();
  return (
    <section className="section-x py-20 sm:py-28">
      <div className="container-tmt">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-primary/20 bg-gradient-surface p-8 shadow-elegant sm:p-14">
            <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary/20 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-28 -left-16 h-72 w-72 rounded-full bg-accent/10 blur-3xl" />
            <div className="relative grid items-center gap-8 lg:grid-cols-[1.4fr_1fr]">
              <div>
                <h2 className="font-display text-3xl font-semibold leading-tight sm:text-4xl">{title}</h2>
                <p className="mt-4 max-w-xl text-base text-muted-foreground sm:text-lg">{subtitle}</p>
              </div>
              <div className="flex flex-col gap-3 lg:items-end">
                <Button variant="hero" size="xl" className="w-full lg:w-auto" onClick={open}>
                  Book Your Consultation <ArrowRight className="h-5 w-5" />
                </Button>
                <a href={COMPANY.phoneHref} className="inline-flex items-center gap-2 font-mono text-sm text-muted-foreground transition-colors hover:text-primary">
                  <PhoneCall className="h-4 w-4" /> {COMPANY.phone}
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
